module.exports = __webpack_public_path__ + "static/media/pizza-1.9a60014b.jpg";